export default {
	Dansk: 'dk',
	English: 'en'
}
  